export default __webpack_public_path__ + "static/media/illustration-study-2-n-w.03d5d1b1.webp";